export default __webpack_public_path__ + "static/orthoBG2-41f4b6fc62dd83609a602687b282afc5.png";